import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { MerchantTransactionsPageContent } from "Components/Transactions/MerchantTransactionsPageContent";
import { CustomerTransactionsPageContent } from "Components/Transactions/CustomerTransactionsPageContent";
import { useIsMobile } from "Hooks/useIsMobile";
import { useIsCurrentUserMerchant } from "Hooks/useIsCurrentUserMerchant";
import { appUrl } from "Utils/UrlUtils";

export const TransactionsPage = () => {
  const { t } = useResource();
  const isMobile = useIsMobile();
  const isMerchant = useIsCurrentUserMerchant();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.TransactionsHistory)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: isMobile ? appUrl("dashboard") : null, // "root" page, nowhere higher to go
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          {isMerchant ? (
            <MerchantTransactionsPageContent />
          ) : (
            <CustomerTransactionsPageContent />
          )}
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default TransactionsPage;
